import React from "react";
import { Typography, Box } from '@mui/material';
import { colors } from "../theme/prototypeTokens";

function FooterV1(){
    return(
        <Box
          component="footer"
          sx={{
            py: 2,
            textAlign: 'center',
            backgroundColor: colors.paper,
            borderTop: `1px solid ${colors.grey200}`,
          }}
        >
          <Typography variant="body2" sx={{ color: colors.grey600, fontSize: '.8rem' }}>
            &copy; {new Date().getFullYear()} Impelsys Private Limited.
          </Typography>
        </Box>
    )
}

export default FooterV1;